import { useCallback, useEffect, useState } from "react";
import {
  adminApi,
  AdminReifegradSettings,
  AdminReifegradSettingsUpdate,
} from "../../../../services/api/admin";

interface UseAdminReifegradSettingsReturn {
  settings: AdminReifegradSettings | null;
  loading: boolean;
  error: string | null;
  save: (data: AdminReifegradSettingsUpdate) => Promise<AdminReifegradSettings>;
}

export const useAdminReifegradSettings = (
  orgId: string,
): UseAdminReifegradSettingsReturn => {
  const [settings, setSettings] = useState<AdminReifegradSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await adminApi.getReifegradSettings(orgId);
      setSettings(data);
    } catch {
      setError("Reifegrad-Score-Einstellungen konnten nicht geladen werden");
    } finally {
      setLoading(false);
    }
  }, [orgId]);

  useEffect(() => {
    load();
  }, [load]);

  const save = useCallback(
    async (
      data: AdminReifegradSettingsUpdate,
    ): Promise<AdminReifegradSettings> => {
      const updated = await adminApi.updateReifegradSettings(orgId, data);
      setSettings(updated);
      return updated;
    },
    [orgId],
  );

  return { settings, loading, error, save };
};
